<template>
  <div id="footer" class="container-fluid">
    <div class="content">
      <div class="logo">
        <div class="left fs-rem-15">
          <!-- <img v-if="$i18n.locale == 'en'" src="../assets/img2/logo-CK3Ah_zb.png" alt="logo图"
            style="margin-bottom: 30px"> -->
          <img src="../assets/img2/logoyw-2M8_saDq.png" alt="logo图" style="margin-bottom: 30px">
          <div class="line">
            <div>
              <p>{{ $t('footer.foo1') }}</p>
              <p>{{ $t('footer.foo2') }}</p>
            </div>
            <div>
              <p>{{ $t('footer.foo3') }}</p>
              <p>(0572)2577088 </p>
            </div>
            <div>
              <p>{{ $t('footer.foo4') }}</p>
              <p>mail@shincen.com</p>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="line">
            <p @click="jumpTo('produce')">{{ $t('header.menu0') }}</p>
            <ul class="mg-r-630">
              <li @click="jumpTo(item)" v-for="(item, index) in productList" :key="index">{{ item.title }}
              </li>
            </ul>
          </div>
          <div class="line">
            <p @click="jumpTo('mark')">{{ $t('header.menu4') }}</p>
            <div class="flex-row">
              <ul>
                <li @click="jumpTo(item)" v-for="(item, index) in markList" :key="index">{{ item.title }}</li>
              </ul>
              <ul>
                <li @click="jumpTo(item)" v-for="(item, index) in markList2" :key="index">{{ item.title }}</li>
              </ul>
            </div>

          </div>
          <div class="line">
            <p @click="jumpTo({ route: 'SalesSupport' })">{{ $t('header.menu5') }}</p>
          </div>
          <div class="line">
            <p @click="jumpTo({ route: 'About' })">{{ $t('header.menu3') }}</p>
            <ul>
              <li @click="jumpTo(item)" v-for="(item, index) in aboutList" :key="index">{{ item.title }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="bottom">
        <!-- <p>Copyrigh © 2024 甚湖科技有限公司 版权所有<span>沪ICP备 04000001号</span></p> -->
        <p class="keep-spaces copyrigh  flex-wrap fs-rem-14" :class="{ 'center mg-b-200': screenSize != 'lg' }">
          Copyright © 2026 新甚科技有限公司 版权所有
          <span>
            <a href="https://beian.miit.gov.cn/" target="_blank" class="color-f">浙ICP备2024139701号</a>
          </span>
          <span class="beian">
            <img class="resentImg" src="../assets/img2/copyrigh.png" alt="logo图" />
             <a href="https://beian.mps.gov.cn/#/query/webSearch?code=33050202001668" rel="noreferrer"
              target="_blank">浙公网安备33050202001668号</a>
          </span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      isEn: true,
    }
  },
  created() {
    console.log('当前语言是222', this.$i18n.locale);
    if (this.$i18n.locale === 'zh') {
      this.isEn = false;
    } else {
      this.isEn = true;
    }
  },
  computed: {
    screenSize() {
      return this.$store.getters.screenSize
    },
    productList() {
      return [
        {
          title: this.$t('EMMC.name'),
          route: 'ProduceType',
          params: {
            itemType: 'embedding'
          }
        },
        {
          title: this.$t('M2.name'),
          route: 'ProduceType',
          params: {
            itemType: 'rdimm'
          }
        },
        {
          title: this.$t('FB.name'),
          route: 'ProduceType',
          params: {
            itemType: 'sd'
          }
        },
      ]
    },
    markList() {
      return [
        {
          title: this.$t('Solution.so0'),
          route: 'IndustryPage',
          params: {
            item: 'dataCenter'
          }
        },
        {
          title: this.$t('Solution.so2'),
          route: 'IndustryPage',
          params: {
            item: 'PC'
          }
        },
        {
          title: this.$t('Solution.so4'),
          route: 'IndustryPage',
          params: {
            item: 'CAR'
          }
        },
        {
          title: this.$t('Solution.so6'),
          route: 'IndustryPage',
          params: {
            item: 'MobilePhone'
          }
        },
        {
          title: this.$t('Solution.so8'),
          route: 'IndustryPage',
          params: {
            item: 'AI'
          }
        },
        {
          title: this.$t('Solution.so10'),
          route: 'IndustryPage',
          params: {
            item: 'Smart'
          }
        },
        // {
        //   title: this.$t('Solution.so12'),
        //   route: 'Network'
        // },
        // {
        //   title: this.$t('Solution.so14'),
        //   route: 'Industrial'
        // }
      ]
    },
    markList2() {
      return [
        {
          title: this.$t('Solution.so12'),
          route: 'IndustryPage',
          params: {
            item: 'Network'
          }
        },
        {
          title: this.$t('Solution.so14'),
          route: 'IndustryPage',
          params: {
            item: 'Industrial'
          }
        }
      ]
    },
    aboutList() {
      return [
        {
          title: this.$t('header.spe10'),
          route: 'AboutView'
        },
        {
          title: this.$t('header.spe11'),
          route: 'MyCaption'
        },
        {
          title: this.$t('header.spe12'),
          route: 'ContUs'
        },
        {
          title: this.$t('header.spe13'),
          route: 'NewsView'
        }
      ]
    }
  },
  methods: {
    jumpTo(item) {
      this.$router.push({ name: item.route, params: item.params || {} })
    }
  }
};
</script>
<style lang="scss" scoped>
#footer {
  width: 100%;
  height: auto;
  color: #fff;
  background: black;
  overflow: hidden;
}

#footer .content {
  width: 90%;
  margin: 0 auto;
}

#footer .content .left .line>div {
  margin-bottom: 2rem;
}

#footer .content .left .line p {
  margin-bottom: 1rem;
}

#footer .content .right {
  display: flex;
  justify-content: space-between;
}

#footer .content .right .line {
  margin-right: 8rem;
}

#footer .content .right .line p {
  font-weight: 400;
  font-size: 1.6rem;
  color: #FFFFFF;
  line-height: 2.2rem;
  margin-bottom: 3.2rem;
}

#footer .content .right .line li {
  cursor: pointer;
  margin-bottom: 2rem;
  font-weight: 400;
  font-size: 1.6rem;
  color: #B2B6BB;
  line-height: 2.2rem;
}

#footer .line .img {
  width: 20px;
  height: 20px;
  margin-right: 1rem;
  display: inline-block;
  vertical-align: middle;
}

.logo {
  display: flex;
  justify-content: space-between;
  padding: 5rem 0;
  margin: 0 auto;
  border-bottom: 1px solid rgba(255, 255, 255, 0.25);
}

.bottom {
  margin-top: 2rem;
  flex: 1;
}

.bottom p {
  height: 100%;
  display: flex;
  align-items: center;
  color: white;
}

.bottom p span {
  padding-left: 2rem;
}

@media screen and (max-width: 1170px) {
  #footer {
    height: auto;
  }

  #footer .content {
    width: 100%;
  }

  #footer .left img {
    margin: 0 auto;
  }

  #footer .left .line {
    margin: 0 auto;
    text-align: center;
  }

  #footer .right {
    display: none !important;
  }

  #footer .logo {
    display: flex;
    justify-content: center;
  }
}

@media screen and (max-width: 997px) {
  #footer {
    height: auto;
  }

  #footer .right {
    display: none !important;
  }
}

.keep-spaces {
  white-space: break-spaces;
}

.color-f {
  color: #fff;

}

.copyrigh img {
  width: 15px;
  height: 15px;
}

.beian {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue